import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { NotificationListItem } from './NotificationListItem';

export class NotificationListTable extends React.Component {

    render() {
        const {
            data,
            error,
            loading,
            resolveNotification,
            hasPermissionToResolve,
        } = this.props;

        if ( error ) {
            return (
                <section className="error-section">
                    <h3 className="text-center">{error}</h3>
                </section>
            );
        }

        if ( !loading && data.length === 0 ) {
            return (
                <section className="error-section">
                    <h3 className="text-center">{I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS')}</h3>
                </section>
            );
        }

        return data.map((notification) => (
            <NotificationListItem
                key={notification.id()}
                notification={notification}
                resolveNotification={resolveNotification}
                hasPermissionToResolve={hasPermissionToResolve}
            />
        ));
    }
}

NotificationListTable.propTypes = {
    data: PropTypes.array,
    error: PropTypes.string,
    loading: PropTypes.bool,
    resolveNotification: PropTypes.func.isRequired,
    hasPermissionToResolve: PropTypes.bool,
};

NotificationListTable.defaultProps = {
    data: [],
    error: '',
    loading: false,
};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/list/NotificationListTable.jsx